import React from "react";
import { useSelector } from "react-redux";
import "./Packs.css";
import { selectPacks } from "../../../../../Store/packSlice";

const Packs = () => {
  const packs = useSelector(selectPacks);
  return (
    <div className="packs-grid">
      {packs &&
        packs.map((pack, index) => (
          <div key={index} className="pack-card">
            <div className="pack-name">{pack?.titre}</div>
            <div className="pack-jetons">{pack?.nombreJeton}</div>
            <div className="pack-jetons-label">Jetons</div>
            <div className="pack-desc">{pack?.description}</div>
            <div className="pack-price">{pack?.prix} DT</div>
          </div>
        ))}
    </div>
  );
};

export default Packs;
